import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './tokens.css';
import { App } from './App';
import { createPlatform } from './platform/create';
import { PlatformProvider } from './platform/context';
import { requestPersistentStorage } from './db/settings';

const root = document.getElementById('root');
if (root === null) {
  throw new Error('#root is missing from index.html');
}

// Everything the user has is in IndexedDB and none of it came from a server.
// Fire and forget: a refused request must not stop the app booting.
void requestPersistentStorage();

// Chosen once, at startup, and passed down. Not a singleton import.
const platform = createPlatform();

// The app shell, so the home-screen icon opens something with no signal. Only
// in a built copy: in `npm run dev` a service worker would serve yesterday's
// modules back to Vite and make hot reload lie. Fire and forget — a browser
// that refuses one still runs the app, it just needs the network to start.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Caught, not `void`ed: the desktop build is also PROD, and it loads from
    // a custom protocol where registration is refused. That refusal is
    // correct — a Tauri app already has its assets locally and needs no
    // cache — but an unhandled rejection would surface it as a fault.
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

createRoot(root).render(
  <StrictMode>
    <PlatformProvider platform={platform}>
      <App />
    </PlatformProvider>
  </StrictMode>,
);
